import { useEffect, useState } from 'react';
import { useSearchParams } from 'react-router';
import { useConsultantAccess } from '../../hooks/consultant/use-consultant-access';
import { useIsMobile } from '../../hooks/use-is-mobile';
import MainLayout from '../../layouts/MainLayout';
import { DEADLINE_HIGHLIGHT_PARAM } from '../../pages/consultant/deadlines/deadline-calendar-link';
import { AssistantShellFrame } from './assistant-shell-frame';

/**
 * Route shell of /consultant/deadlines: the standard layout plus the assistant
 * FAB and panel. On a phone the drawer covers the calendar, so a "Vedi nel
 * calendario" jump (which writes `highlight`) closes it.
 *
 * Mounted ONLY when the consultant AI is on (`consultantAiEnabled` of
 * `GET /consultant/access`, never re-derived: a studio AND the back-office
 * switch): the turn bills the studio and fails without either. While the flag
 * loads nothing is offered, so the FAB never appears only to vanish.
 */
export function ConsultantDeadlinesAssistantShell() {
  const { consultantAiEnabled, isPending: consultantAccessPending } = useConsultantAccess();
  const [searchParams] = useSearchParams();
  const isMobile = useIsMobile();
  const [assistantOpen, setAssistantOpen] = useState(false);
  const requestedHighlight = searchParams.get(DEADLINE_HIGHLIGHT_PARAM);

  useEffect(() => {
    if (requestedHighlight && isMobile) {
      setAssistantOpen(false);
    }
  }, [requestedHighlight, isMobile]);

  if (consultantAccessPending || !consultantAiEnabled) {
    return <MainLayout />;
  }

  return (
    <>
      <MainLayout />
      <AssistantShellFrame onOpenChange={setAssistantOpen} open={assistantOpen} />
    </>
  );
}
